module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('article', {
    class: {
      'card-folded': true,
      'card--open': _vm.isOpen,
      'card--closed': _vm.isClosed,
      'card--horizontal': _vm.orientation == 'horizontal',
        'card--vertical': _vm.orientation != 'horizontal',
    },
    on: {
      "click": function($event) {
        _vm.handleClick($event)
      }
    }
  }, [_c('section', {
    staticClass: "card-panel-cover"
  }, [_c('section', {
    staticClass: "card-side-front"
  }, [_vm._t("cover-front")], 2), _vm._v(" "), _c('section', {
    staticClass: "card-side-back"
  }, [_vm._t("cover-back")], 2)]), _vm._v(" "), _c('section', {
    staticClass: "card-panel-back"
  }, [_c('section', {
    staticClass: "card-side-front"
  }, [_vm._t("backing-front")], 2), _vm._v(" "), _c('section', {
    staticClass: "card-side-back"
  }, [_vm._t("backing-back")], 2)])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-9d6cd52c","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/folded-card.vue
// module id = 37
// module chunks = 0